module.exports = __webpack_public_path__ + "img/title-4.d7628d40.png";